import * as CreateContractCorrectionTypes from 'src/actions/contract-corrections/create/Types';
import { CreateCorrectionContractAction }
  from 'src/actions/contract-corrections/create/CreateContractCorrections.actions';

export interface CreateCorrectContractState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: CreateCorrectContractState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function CreateCorrectionContractReducer(state: CreateCorrectContractState = initialState,
                                                action: CreateCorrectionContractAction): CreateCorrectContractState {
  switch (action.type) {
    case CreateContractCorrectionTypes.CREATE_CORRECTION_CONTRACT_ATTEMPT:
      return {...state, loading: true, error: false};
    case CreateContractCorrectionTypes.CREATE_CORRECTION_CONTRACT_SUCCESS:
      return {...state, loading: false, error: false};
    case CreateContractCorrectionTypes.CREATE_CORRECTION_CONTRACT_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/correct-contract/CreateCorrectionContractReducer.tsx